/** NUMELE FELURILOR CANONICE, în limba ecranului.
 *
 *  `generated/kinds.ts` e vocabularul canonic: o singură listă de feluri, de
 *  care ascultă și motorul, și browserul. Etichetele lui sunt însă ROMÂNEȘTI,
 *  fiindcă tabelul se generează din `kinds.py`, unde sunt scrise o dată pentru
 *  toată platforma. Pe ecran numele unui fel e text de interfață ca oricare
 *  altul, deci stă în catalogul de traduceri.
 *
 *  TABELUL GENERAT RĂMÂNE PLASA, nu dispare: un fel adăugat în `kinds.py` și
 *  neajuns încă în catalog se vede cu eticheta lui românească, nu cu o cheie
 *  crudă pe ecranul cuiva. Legătura dintre cele două o ține un test
 *  (`vocabular.test.ts`): orice fel din `LABEL` trebuie să aibă `kind.<fel>`.
 *
 *  Aceeași regulă ca la felurile de cameră ale tronsonului — v.
 *  `tronson/feluri.ts`, care a fost primul care a făcut-o.
 */
import { LABEL, STOREY_LABEL } from "./generated/kinds";
import type { StoreyKind } from "./generated/kinds";
import { t } from "../i18n";
import type { Cheie } from "../i18n";

/** Numele unui fel canonic (`column`, `balcony`, `ada_aisle`…). */
export function numeleFelului(kind: string | null | undefined): string {
  if (!kind) return "";
  return kind in LABEL ? t(`kind.${kind}` as Cheie) : kind;
}

/** Numele unui fel de nivel (`ground`, `parking`…). */
export function numeleNivelului(kind: string | null | undefined): string {
  if (!kind) return "";
  return kind in STOREY_LABEL
    ? t(`nivel.${kind as StoreyKind}` as Cheie) : kind;
}
